var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageList"},_vm._l((_vm.pages),function(page){return _c('RecordPage',{key:page.id,attrs:{"page":page}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }